<section class="grid grid-cols-1 items-center gap-8 md:grid-cols-2 md:gap-16">
    <div
        class="space-y-4 px-4 md:p-0"
        [ngClass]="dayNumber % 2 ? 'md:order-1' : 'md:order-2'">
        <h3 class="font-semibold">Day {{ dayNumber }}: {{ day?.title }}</h3>
        <p class="text-deemphasized">
            <app-rich-text-document
                [document]="day?.description?.json"></app-rich-text-document>
        </p>
    </div>
    <div [ngClass]="dayNumber % 2 ? 'md:order-2' : 'md:order-1'">
        <div class="aspect-h-1 aspect-w-1 md:aspect-h-9 md:aspect-w-16">
            @if (day?.featuredImage?.url) {
                <app-lazy-picture
                    [additionalClasses]="['rounded-lg']"
                    [configurations]="
                        featuredImageConfiguration
                    "></app-lazy-picture>
            }
        </div>
    </div>
</section>
